import { useEffect, useState } from "react";
import { format } from "date-fns";
import { CalendarOff } from "lucide-react";
import { api, formatTime } from "@/lib/api";

const d = (s) => new Date(`${s}T00:00:00`);

export const leaveDates = (start, end) => {
  if (start === end) return format(d(start), "d MMM");
  if (start.slice(0, 7) === end.slice(0, 7)) return `${format(d(start), "d")}–${format(d(end), "d MMM")}`;
  return `${format(d(start), "d MMM")} – ${format(d(end), "d MMM")}`;
};

const describe = (lv) => {
  const hours = lv.start_time ? `, ${formatTime(lv.start_time)} – ${formatTime(lv.end_time)}` : "";
  const where = lv.all_clinics ? "" : ` (${lv.clinics.join(", ")})`;
  return `${leaveDates(lv.start_date, lv.end_date)}${hours}${where}`;
};

export const LeaveNotice = () => {
  const [leaves, setLeaves] = useState([]);
  useEffect(() => {
    api.get("/leaves").then((r) => setLeaves(r.data)).catch(() => setLeaves([]));
  }, []);
  if (!leaves.length) return null;
  return (
    <div className="bg-[#DC2626] text-white" data-testid="leave-notice">
      <div className="max-w-7xl mx-auto px-6 py-3 flex flex-wrap items-center gap-x-3 gap-y-1 text-sm">
        <CalendarOff className="h-4 w-4 shrink-0" />
        <p className="font-semibold" data-testid="leave-notice-text">
          Doctor on leave {leaves.map(describe).join(" · ")}
        </p>
        <a href="#book" className="underline underline-offset-4 font-medium hover:opacity-90" data-testid="leave-notice-book-link">Book another day</a>
      </div>
    </div>
  );
};
